export const formatMoeda = (v) =>
  v != null
    ? Number(v).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
    : '—';

export const formatNumero = (v, decimais = 0) =>
  v != null ? Number(v).toLocaleString('pt-BR', { minimumFractionDigits: decimais }) : '—';
